import {
  MISSING_CLINICAL_REASON_CODE,
  MISSING_CLINICAL_REASON_MESSAGE,
} from '@/lib/referral/xref01Validation';

function apiCallCodeAndMessage(err: unknown): { code: string; message: string } | null {
  if (!err || typeof err !== 'object') return null;
  if (!('name' in err) || err.name !== 'ApiCallError') return null;
  if (!('code' in err) || typeof err.code !== 'string') return null;
  if (!('message' in err) || typeof err.message !== 'string') return null;
  return { code: err.code, message: err.message };
}

export function referralBuildFailureMessage(err: unknown, fallback: string): string {
  const api = apiCallCodeAndMessage(err);
  if (!api) return fallback;
  if (api.code === MISSING_CLINICAL_REASON_CODE) {
    const message = api.message.trim();
    return message.length > 0 ? message : MISSING_CLINICAL_REASON_MESSAGE;
  }
  const message = api.message.trim();
  return message.length > 0 ? message : fallback;
}
